import React from 'react';

// Hook for preloading images in the background
export const useBackgroundImagePreloader = (images: string[]) => {
  const [preloadedImages, setPreloadedImages] = React.useState<Set<string>>(new Set());
  const [isPreloading, setIsPreloading] = React.useState(false);

  const preloadImages = React.useCallback(async () => {
    if (images.length === 0) return;

    setIsPreloading(true);
    const loaded = new Set<string>();

    const preloadPromises = images.map((url) => {
      if (!url) return Promise.resolve();
      
      return new Promise<void>((resolve) => {
        const img = new Image();
        img.onload = () => {
          loaded.add(url);
          resolve();
        };
        img.onerror = () => {
          // Still resolve even if image fails to load
          resolve();
        };
        img.src = url;
      });
    });

    await Promise.all(preloadPromises);
    setPreloadedImages(loaded);
    setIsPreloading(false);
  }, [images]);

  React.useEffect(() => {
    preloadImages();
  }, [preloadImages]);

  return {
    preloadedImages,
    isPreloading,
    isImagePreloaded: (url: string) => preloadedImages.has(url),
  };
}; 